import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

const headlines = [
  {
    desktop: {
      Family: 'Helvetica Neue',
      Weight: 'Medium',
      Size: 80,
      "Line Height": '110%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    mobile: {
      Family: 'Helvetica Neue',
      Weight: 'Medium',
      Size: 64,
      "Line Height": '116%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    example: 'This is an H1 headline. The quick brown fox',
    tag: 'h1'
  },
  {
    desktop: {
      Family: 'Helvetica Neue',
      Weight: 'Medium',
      Size: 64,
      "Line Height": '116%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    mobile: {
      Family: 'Helvetica Neue',
      Weight: 'Medium',
      Size: 48,
      "Line Height": '120%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    example: 'This is an H2 headline. The quick brown fox jumps.',
    tag: 'h2'
  },
  {
    desktop: {
      Family: 'Helvetica Neue',
      Weight: 'Medium',
      Size: 48,
      "Line Height": '120%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    mobile: {
      Family: 'Helvetica Neue',
      Weight: 'Medium',
      Size: 32,
      "Line Height": '130%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    example: 'This is an H3 headline. The quick brown fox jumps.',
    tag: 'h3'
  },
  {
    desktop: {
      Family: 'Helvetica Neue',
      Weight: 'Medium',
      Size: 32,
      "Line Height": '130%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    mobile: {
      Family: 'Helvetica Neue',
      Weight: 'Medium',
      Size: 24,
      "Line Height": '130%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    example: 'This is an H4 headline. The quick brown fox jumps.',
    tag: 'h4'
  },
  {
    desktop: {
      Family: 'Helvetica Neue',
      Weight: 'Medium',
      Size: 24,
      "Line Height": '130%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    mobile: {
      Family: 'Helvetica Neue',
      Weight: 'Medium',
      Size: 18,
      "Line Height": '130%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    example: 'This is an H5 headline. The quick brown fox jumps.',
    tag: 'h5'
  },
  {
    desktop: {
      Family: 'Helvetica Neue',
      Weight: 'Medium',
      Size: 18,
      "Line Height": '130%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    mobile: {
      Family: 'Helvetica Neue',
      Weight: 'Medium',
      Size: 16,
      "Line Height": '130%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    example: 'This is an H6 headline. The quick brown fox jumps.',
    tag: 'h6'
  }
];

const bodies = [
  {
    props: {
      Family: 'Helvetica Neue',
      Weight: 'Regular, Medium',
      Size: 16,
      "Line Height": '150%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    title: 'Medium 1',
    classNameMedium: 'text-medium-1',
    className: 'text-1',
    example: 'Regular 1 lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
  },
  {
    props: {
      Family: 'Helvetica Neue',
      Weight: 'Regular, Medium',
      Size: 14,
      "Line Height": '150%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    title: 'Medium 2',
    classNameMedium: 'text-medium-2',
    className: 'text-2',
    example: 'Regular 2 lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
  },
  {
    props: {
      Family: 'Helvetica Neue',
      Weight: 'Regular, Medium',
      Size: 12,
      "Line Height": '150%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    title: 'Medium 3',
    classNameMedium: 'text-medium-3',
    className: 'text-3',
    example: 'Regular 3 lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
  }
];

const system = [
  {
    props: {
      Family: 'Helvetica Neue',
      Weight: 'Bold',
      Size: 12,
      "Line Height": '150%',
      Spacing: '8%',
      Case: 'Title case'
    },
    className: 'eyebrow',
    example: 'eyebrow'
  },
  {
    props: {
      Family: 'Helvetica Neue',
      Weight: 'Regular, Medium',
      Size: 14,
      "Line Height": '150%',
      Spacing: '0%',
      Case: 'Sentence case'
    },
    className: 'btn',
    example: 'Button'

  }
];

class Typography extends React.Component {

  constructor(props) {
    super(props);
  }

  renderProps(properties) {
    const rows = [];
    for (const key in properties) {
      if (Object.hasOwnProperty.call(properties, key)) {
        const element = properties[key];
        rows.push(<Row key={key}>
          <Col className="body-medium-2" sm={5}>
            {key}:
          </Col>
          <Col className="body-medium-2" sm={7}>
            {element}
          </Col>
        </Row>);
      }
    }
    return rows;
  }

  render() {
    const { t } = this.props;
    return (
      <Container style={{ marginTop: 80 }}>
        <h3 className="mb-4">
          {t('influencers.pages.styleguide.typography')}
        </h3>

        <Row>
          <Col sm={12} >
            <h5 className="mb-4">
              {t('influencers.pages.typography.headline')}
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={6} sm={3}>
            <h6>
              {t('influencers.pages.typography.tablet_bigger')}
            </h6>
          </Col>
          <Col xs={6} sm={3}>
            <h6>
              {t('influencers.pages.typography.phone')}
            </h6>
          </Col>
        </Row>

        {
          headlines.map(headline => {
            const Tag = headline.tag;
            return (
              <Row className="mb-5" key={headline.tag}>
                <Col xs={6} sm={3} className="mb-2">
                  {this.renderProps(headline.desktop)}
                </Col>

                <Col xs={6} sm={3} className="mb-2">
                  {this.renderProps(headline.mobile)}
                </Col>

                <Col xs={12} sm={6}>
                  <Tag>
                    {headline.example}
                  </Tag>
                </Col>
              </Row >
            );
          })
        }

        <Row>
          <Col sm={12} >
            <h5>
              {t('influencers.pages.typography.body')}
            </h5>
          </Col>
        </Row>

        {
          bodies.map(body => (
            <Row className="mb-5" key={body.title}>
              <Col xs={6} sm={3} className="mb-2">
                {this.renderProps(body.props)}
              </Col>

              <Col xs={6} sm={3} className="mb-2">
                <div className={body.classNameMedium}>
                  {body.title}
                </div>
              </Col>

              <Col xs={12} sm={6}>
                <div className={body.className}>
                  {body.example}
                </div>
              </Col>
            </Row >
          ))
        }

        <Row>
          <Col sm={12} >
            <h5>
              {t('influencers.pages.typography.system_ui')}
            </h5>
          </Col>
        </Row>

        {
          system.map(ui => (
            <Row className="mb-5" key={ui.example}>
              <Col xs={6} sm={3} className="mb-2">
                {this.renderProps(ui.props)}
              </Col>

              <Col xs={12} sm={9}>
                <div className={ui.className}>
                  {ui.example}
                </div>
              </Col>
            </Row >
          ))
        }

      </Container >
    );
  }
}

export default withTranslation()(Typography);